<template>
  <div class="px-8 py-6">
    <a-modal
      v-if="selfMonitoringData"
      title="ข้อมูลจาก CMU Smart Self-Monitoring"
      :visible="selfMonitoringModalVisiblity"
      :maskClosable="true"
      @cancel="selfMonitoringModalVisiblity = false"
      @ok="selfMonitoringModalVisiblity = false"
    >
      <div class="bg-white">
        <dl>
          <div
            class="bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
          >
            <dt class="text-sm leading-5 font-medium text-gray-500">
              การออกกำลังกาย
            </dt>
            <dd
              class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2"
            >
              {{
                selfMonitoringData.workout !== "N"
                  ? "มีการออกกำลังกาย"
                  : "ไม่ได้ออกกำลังกาย"
              }}
            </dd>
          </div>
          <div
            class="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
          >
            <dt class="text-sm leading-5 font-medium text-gray-500">
              การเดิน
            </dt>
            <dd
              class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2"
            >
              {{ selfMonitoringData.steps }} ก้าว
            </dd>
          </div>
          <div
            class="bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
          >
            <dt class="text-sm leading-5 font-medium text-gray-500">
              ส่วนสูง
            </dt>
            <dd
              class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2"
            >
              {{ selfMonitoringData.height }}
            </dd>
          </div>
          <div
            class="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
          >
            <dt class="text-sm leading-5 font-medium text-gray-500">
              น้ำหนัก
            </dt>
            <dd
              class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2"
            >
              {{ selfMonitoringData.weight }}
            </dd>
          </div>
           <div
            class="bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
          >
            <dt class="text-sm leading-5 font-medium text-gray-500">
              น้ำหนักที่ควรจะเป็น
            </dt>
            <dd
              class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2"
            >
              {{ selfMonitoringData.idealWeight }}
            </dd>
          </div>
          <div
            class="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
          >
            <dt class="text-sm leading-5 font-medium text-gray-500">
              ระดับออกซิเจนในเลือด
            </dt>
            <dd
              class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2"
            >
              {{ selfMonitoringData.bloodOxygen }}
            </dd>
          </div>
          <div
            class="bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
          >
            <dt class="text-sm leading-5 font-medium text-gray-500">
              ความดันโลหิต
            </dt>
            <dd
              class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2"
            >
              {{ selfMonitoringData.bpLow }} / {{ selfMonitoringData.bpHigh }}
            </dd>
          </div>
          <div
            class="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
          >
            <dt class="text-sm leading-5 font-medium text-gray-500">
              ไขมัน
            </dt>
            <dd
              class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2"
            >
              {{ selfMonitoringData.fatMass }}
            </dd>
          </div>
        </dl>
      </div>
    </a-modal>

    <div v-show="hasMonitoringData" class="w-full h-16 flex items-center">
      <img
        class="w-8 h-8 mr-2"
        src="https://play-lh.googleusercontent.com/rrdM_ydeVME72ZiLIJcIZujQWfsuJhHbfo7MbpjMgBOqDr7LSX-pBcb1BTN9HgNJug=s180-rw"
        alt=""
      />

      มีการใช้มูลจากแอปพลิเคชัน CMU Smart Self-Monitoring
      เพื่อช่วยคุณตอบแบบประเมินนี้

      <button
        class="text-primary ml-2"
        @click="() => (selfMonitoringModalVisiblity = true)"
      >
        รายละเอียด
      </button>
    </div>

    <div>
      <div class="mb-8 hidden md:block">
        <a-steps :current="currentStep" size="small">
          <a-step title="ประวัติส่วนบุคคล" />
          <a-step title="ครอบครัว" />
          <a-step title="พฤติกรรมเสี่ยง" />
          <a-step title="การออกกำลังกาย" />
          <a-step title="การบริโภคอาหาร" />
          <a-step title="การรับประทานยา" />
          <a-step title="สารเสพติด" />
          <a-step title="ความเครียด" />
          <a-step title="การตรวจร่างกาย" />
        </a-steps>
      </div>

      <div id="step-first" v-show="currentStep == 0">
        <h1 class="text-2xl mb-4">ประวัติส่วนบุคคล</h1>

        <div class="flex flex-col md:flex-row mb-16">
          <div class="w-96">
            <h1 class="text-xl font-light"></h1>
          </div>
          <div>
            <div>
              <!-- <a-form-item label="รายได้เฉลี่ยต่อเดือน" class="w-full md:w-64 md:mr-8">
                <a-input v-model="$v.answers.firstStep.salary.$model" type="number" />
              </a-form-item> -->

              <a-form-item label="ค่าใช้จ่ายต่อเดือน">
                <a-radio-group
                  v-model="$v.answers.firstStep.lifeCost.$model"
                  buttonStyle="solid"
                >
                  <a-radio-button class="answer-radio" value="พอเพียง"
                    >พอเพียง</a-radio-button
                  >
                  <a-radio-button class="answer-radio" value="ไม่พอเพียง"
                    >ไม่พอเพียง</a-radio-button
                  >
                  <a-radio-button class="answer-radio" value="เป็นหนี้"
                    >เป็นหนี้</a-radio-button
                  >
                  <a-radio-button class="answer-radio" value="เหลือเก็บ"
                    >เหลือเก็บ</a-radio-button
                  >
                </a-radio-group>
              </a-form-item>

              <a-form-item label="ลักษณะงาน">
                <a-radio-group
                  v-model="$v.answers.firstStep.kindOfWork.$model"
                  buttonStyle="solid"
                >
                  <a-radio-button class="answer-radio" value="ทำงานกลางแจ้ง"
                    >ทำงานกลางแจ้ง</a-radio-button
                  >
                  <a-radio-button class="answer-radio" value="นั่งกับโต๊ะ"
                    >นั่งกับโต๊ะ</a-radio-button
                  >
                  <a-radio-button
                    class="answer-radio"
                    value="เดินไปเดินมางบ้างเล็กน้อย"
                    >เดินไปเดินมางบ้างเล็กน้อย</a-radio-button
                  >
                  <a-radio-button class="answer-radio" value="เดินไปมาส่วนใหญ่"
                    >เดินไปมาส่วนใหญ่</a-radio-button
                  >
                </a-radio-group>
              </a-form-item>

              <a-form-item class="w-full md:w-64">
                <a-button
                  @click="next()"
                  :disabled="$v.answers.firstStep.$invalid"
                  type="primary"
                  html-type="submit"
                  class="w-full md:w-64"
                  >ขั้นตอนต่อไป</a-button
                >
              </a-form-item>
            </div>
          </div>
        </div>
      </div>

      <div id="step-second" v-show="currentStep == 1">
        <h1 class="text-2xl mb-4">ประวัติครอบครัว</h1>

        <div class="flex flex-col md:flex-row mb-16">
          <div class="w-96"></div>
          <div>
            <div>
              <a-form-item label="บิดา" class>
                <a-radio-group
                  buttonStyle="solid"
                  v-model="$v.answers.secondStep.fatherDisease.$model"
                >
                  <a-radio-button class="answer-radio" value="โรคเบาหวาน"
                    >โรคเบาหวาน</a-radio-button
                  >
                  <a-radio-button class="answer-radio" value="ความดันโลหิตสูง"
                    >ความดันโลหิตสูง</a-radio-button
                  >
                  <a-radio-button class="answer-radio" value="โรคหลอดเลือดหัวใจ"
                    >โรคหลอดเลือดหัวใจ</a-radio-button
                  >
                  <a-radio-button class="answer-radio" value="ไม่มี"
                    >ไม่มี</a-radio-button
                  >
                </a-radio-group>
              </a-form-item>

              <a-form-item label="มารดา" class>
                <a-radio-group
                  buttonStyle="solid"
                  v-model="$v.answers.secondStep.motherDisease.$model"
                >
                  <a-radio-button class="answer-radio" value="โรคเบาหวาน"
                    >โรคเบาหวาน</a-radio-button
                  >
                  <a-radio-button class="answer-radio" value="ความดันโลหิตสูง"
                    >ความดันโลหิตสูง</a-radio-button
                  >
                  <a-radio-button class="answer-radio" value="โรคหลอดเลือดหัวใจ"
                    >โรคหลอดเลือดหัวใจ</a-radio-button
                  >
                  <a-radio-button class="answer-radio" value="ไม่มี"
                    >ไม่มี</a-radio-button
                  >
                </a-radio-group>
              </a-form-item>

              <a-form-item label="พี่น้อง" class>
                <a-radio-group
                  buttonStyle="solid"
                  v-model="$v.answers.secondStep.sibblingDisease.$model"
                >
                  <a-radio-button class="answer-radio" value="โรคเบาหวาน"
                    >โรคเบาหวาน</a-radio-button
                  >
                  <a-radio-button class="answer-radio" value="ความดันโลหิตสูง"
                    >ความดันโลหิตสูง</a-radio-button
                  >
                  <a-radio-button class="answer-radio" value="โรคหลอดเลือดหัวใจ"
                    >โรคหลอดเลือดหัวใจ</a-radio-button
                  >
                  <a-radio-button class="answer-radio" value="ไม่มี"
                    >ไม่มี</a-radio-button
                  >
                </a-radio-group>
              </a-form-item>

              <a-form-item class="w-full md:w-64">
                <a-button
                  @click="next()"
                  :disabled="$v.answers.secondStep.$invalid"
                  type="primary"
                  html-type="submit"
                  class="w-full md:w-64"
                  >ขั้นตอนต่อไป</a-button
                >
              </a-form-item>
            </div>
          </div>
        </div>
      </div>

      <div id="step-third" v-show="currentStep == 2">
        <h1 class="text-2xl mb-4">พฤติกรรมเสี่ยงสุขภาพ</h1>

        <div class="flex flex-col md:flex-row">
          <div class="w-96">
            <!-- <h1 class="text-xl font-light">ท่านมีปัญหา/กิจกรรม</h1> -->
          </div>
          <div>
            <div>
              <a-form-item label="ท่านมีผลตรวจสุขภาพประจำปี" class>
                <a-radio-group
                  buttonStyle="solid"
                  v-model="$v.answers.thirdStep.yearlyHealthCheck.$model"
                >
                  <a-radio-button class="answer-radio" value="มี"
                    >มี</a-radio-button
                  >
                  <a-radio-button class="answer-radio" value="ไม่มี"
                    >ไม่มี</a-radio-button
                  >
                  <a-radio-button class="answer-radio" value="ไม่ทราบ"
                    >ไม่ทราบ</a-radio-button
                  >
                </a-radio-group>
              </a-form-item>

              <a-form-item label="ท่านมีภาวะอ้วนในวัยเด็กหรือไม่" class>
                <a-radio-group
                  buttonStyle="solid"
                  v-model="$v.answers.thirdStep.fatWhenWasChild.$model"
                >
                  <a-radio-button class="answer-radio" value="มี"
                    >มี</a-radio-button
                  >
                  <a-radio-button class="answer-radio" value="ไม่มี"
                    >ไม่มี</a-radio-button
                  >
                  <a-radio-button class="answer-radio" value="ไม่ทราบ"
                    >ไม่ทราบ</a-radio-button
                  >
                </a-radio-group>
              </a-form-item>

              <a-form-item label="มีปัญหาด้านโรคเบาหวาน" class>
                <a-radio-group
                  buttonStyle="solid"
                  v-model="$v.answers.thirdStep.diabetes.$model"
                >
                  <a-radio-button class="answer-radio" value="มี"
                    >มี</a-radio-button
                  >
                  <a-radio-button class="answer-radio" value="ไม่มี"
                    >ไม่มี</a-radio-button
                  >
                  <a-radio-button class="answer-radio" value="ไม่ทราบ"
                    >ไม่ทราบ</a-radio-button
                  >
                </a-radio-group>
              </a-form-item>

              <a-form-item label="มีปัญหาด้านความดันโลหิตสูง" class>
                <a-radio-group
                  buttonStyle="solid"
                  v-model="$v.answers.thirdStep.bloodPressure.$model"
                >
                  <a-radio-button class="answer-radio" value="มี"
                    >มี</a-radio-button
                  >
                  <a-radio-button class="answer-radio" value="ไม่มี"
                    >ไม่มี</a-radio-button
                  >
                  <a-radio-button class="answer-radio" value="ไม่ทราบ"
                    >ไม่ทราบ</a-radio-button
                  >
                </a-radio-group>
              </a-form-item>

              <a-form-item label="มีปัญหาด้านโรคหัวใจและหลอดเลือด" class>
                <a-radio-group
                  buttonStyle="solid"
                  v-model="$v.answers.thirdStep.storke.$model"
                >
                  <a-radio-button class="answer-radio" value="มี"
                    >มี</a-radio-button
                  >
                  <a-radio-button class="answer-radio" value="ไม่มี"
                    >ไม่มี</a-radio-button
                  >
                  <a-radio-button class="answer-radio" value="ไม่ทราบ"
                    >ไม่ทราบ</a-radio-button
                  >
                </a-radio-group>
              </a-form-item>

              <a-form-item label="มีปัญหาด้านโรคตับ" class>
                <a-radio-group
                  buttonStyle="solid"
                  v-model="$v.answers.thirdStep.liver.$model"
                >
                  <a-radio-button class="answer-radio" value="มี"
                    >มี</a-radio-button
                  >
                  <a-radio-button class="answer-radio" value="ไม่มี"
                    >ไม่มี</a-radio-button
                  >
                  <a-radio-button class="answer-radio" value="ไม่ทราบ"
                    >ไม่ทราบ</a-radio-button
                  >
                </a-radio-group>
              </a-form-item>
            </div>
          </div>
        </div>

        <div v-show="hasAnyDisease" class="flex flex-col md:flex-row">
          <div class="w-96">
            <h1 class="text-xl font-light">กรณีมีโรคดังกล่าว</h1>
          </div>
          <div>
            <div>
              <a-form-item label="ท่านรักษา">
                <a-radio-group
                  buttonStyle="solid"
                  v-model="answers.thirdStep.treatmentFrequency"
                >
                  <a-radio-button class="answer-radio" value="สม่ำเสมอ"
                    >สม่ำเสมอ</a-radio-button
                  >
                  <a-radio-button class="answer-radio" value="ไม่แน่นอน"
                    >ไม่แน่นอน</a-radio-button
                  >
                  <a-radio-button class="answer-radio" value="หายแล้ว"
                    >หายแล้ว</a-radio-button
                  >
                </a-radio-group>
              </a-form-item>
            </div>
          </div>
        </div>

        <div class="flex w-full">
          <div class="w-96 hidden md:block"></div>
          <a-form-item class="w-full md:w-64">
            <a-button
              @click="next"
              :disabled="$v.answers.thirdStep.$invalid"
              type="primary"
              html-type="submit"
              class="w-full md:w-64"
              >ขั้นตอนต่อไป</a-button
            >
          </a-form-item>
        </div>
      </div>

      <div id="step-forth" v-show="currentStep == 3">
        <h1 class="text-2xl mb-4">การออกกำลังกาย</h1>

        <div class="flex flex-col md:flex-row mb-16">
          <div class="w-96"></div>
          <div>
            <div>
              <a-form-item label="ได้ออกกำลังหรือไม่">
                <p class="text-gray-400">
                  {{
                    selfMonitoringData && selfMonitoringData.workout !== "-"
                      ? "(ข้อมูลจาก CMU Smart Self-Monitoring)"
                      : ""
                  }}
                </p>
                <a-radio-group
                  buttonStyle="solid"
                  v-model="$v.answers.forthStep.hasExercise.$model"
                >
                  <a-radio-button class="answer-radio" value="ออกกำลังกาย"
                    >ออกกำลังกาย</a-radio-button
                  >
                  <a-radio-button class="answer-radio" value="ไม่ได้ออกกำลังกาย"
                    >ไม่ได้ออกกำลังกาย</a-radio-button
                  >
                </a-radio-group>
              </a-form-item>
              <a-form-item v-if="hasExercise" label="ความถี่">
                <a-radio-group
                  buttonStyle="solid"
                  v-model="$v.answers.forthStep.exerciseFrequency.$model"
                >
                  <a-radio-button class="answer-radio" value="ทุกวัน"
                    >ทุกวัน</a-radio-button
                  >
                  <a-radio-button
                    class="answer-radio"
                    value="น้อยกว่า 2 ครั้งต่อสัปดาห์"
                    >น้อยกว่า 2 ครั้งต่อสัปดาห์</a-radio-button
                  >

                  <a-radio-button class="answer-radio" value="ไม่แน่นอน"
                    >ไม่แน่นอน</a-radio-button
                  >
                </a-radio-group>
              </a-form-item>

              <a-form-item v-if="hasExercise" label="เวลานาน">
                <a-radio-group
                  buttonStyle="solid"
                  v-model="$v.answers.forthStep.exerciseDuration.$model"
                >
                  <a-radio-button
                    class="answer-radio"
                    value="น้อยกว่า 30 นาที/ครั้ง"
                    >น้อยกว่า 30 นาที/ครั้ง</a-radio-button
                  >

                  <a-radio-button
                    class="answer-radio"
                    value="มากกว่า 30 นาที/ครั้ง"
                    >มากกว่า 30 นาที/ครั้ง</a-radio-button
                  >

                  <a-radio-button class="answer-radio" value="ไม่แน่นอน"
                    >ไม่แน่นอน</a-radio-button
                  >
                </a-radio-group>
              </a-form-item>

              <a-form-item v-if="hasExercise" label="ประเภทการออกกำลังกาย">
                <a-radio-group
                  buttonStyle="solid"
                  v-model="$v.answers.forthStep.exerciseType.$model"
                >
                  <a-radio-button class="answer-radio" value="วิ่ง"
                    >วิ่ง</a-radio-button
                  >

                  <a-radio-button class="answer-radio" value="เดิน"
                    >เดิน</a-radio-button
                  >

                  <a-radio-button class="answer-radio" value="อื่นๆ"
                    >อื่นๆ</a-radio-button
                  >
                </a-radio-group>
              </a-form-item>

              <a-form-item class="w-full md:w-64">
                <a-button
                  @click="next()"
                  :disabled="$v.answers.forthStep.$invalid"
                  type="primary"
                  html-type="submit"
                  class="w-full md:w-64"
                  >ขั้นตอนต่อไป</a-button
                >
              </a-form-item>
            </div>
          </div>
        </div>
      </div>

      <div id="step-fifth" v-show="currentStep == 4">
        <h1 class="text-2xl mb-4">การบริโภคอาหาร</h1>

        <div class="flex flex-col md:flex-row">
          <div class="w-96">
            <h1 class="text-xl font-light">แหล่งอาหาร</h1>
          </div>
          <a-form-item label="แหล่งอาหารส่วนใหญ่">
            <a-radio-group
              v-model="$v.answers.fifthStep.foodSource.$model"
              class="w-full"
              buttonStyle="solid"
            >
              <a-radio-button class="answer-radio" value="ทำกินเอง"
                >ทำกินเอง</a-radio-button
              >
              <a-radio-button class="answer-radio" value="ซื้อสำเร็จรูป"
                >ซื้อสำเร็จรูป</a-radio-button
              >
              <a-radio-button class="answer-radio" value="ทั้งสองอย่าง"
                >ทั้งสองอย่าง</a-radio-button
              >
            </a-radio-group>
          </a-form-item>
        </div>

        <div class="flex flex-col md:flex-row mb-16">
          <div class="w-96">
            <h1 class="text-xl font-light">ประเภทอาหาร</h1>
          </div>
          <div>
            <div>
              <a-form-item label="ไขมัน, เนื้อสัตว์ติดมัน" class>
                <a-radio-group
                  v-model="$v.answers.fifthStep.foodFat.$model"
                  class="w-full"
                  buttonStyle="solid"
                >
                  <a-radio-button class="answer-radio" value="ทุกวัน"
                    >ทุกวัน</a-radio-button
                  >
                  <a-radio-button class="answer-radio" value="นานๆครั้ง"
                    >นานๆครั้ง</a-radio-button
                  >
                  <a-radio-button class="answer-radio" value="บางวัน"
                    >บางวัน</a-radio-button
                  >
                </a-radio-group>
              </a-form-item>

              <a-form-item label="แกงกะทิ" class>
                <a-radio-group
                  v-model="$v.answers.fifthStep.foodCoconutMilk.$model"
                  class="w-full"
                  buttonStyle="solid"
                >
                  <a-radio-button class="answer-radio" value="ทุกวัน"
                    >ทุกวัน</a-radio-button
                  >
                  <a-radio-button class="answer-radio" value="นานๆครั้ง"
                    >นานๆครั้ง</a-radio-button
                  >
                  <a-radio-button class="answer-radio" value="บางวัน"
                    >บางวัน</a-radio-button
                  >
                </a-radio-group>
              </a-form-item>

              <a-form-item label="รสชาติที่ชอบส่วนใหญ่" class>
                <a-radio-group
                  v-model="$v.answers.fifthStep.foodTaste.$model"
                  class="w-full"
                  buttonStyle="solid"
                >
                  <a-radio-button class="answer-radio" value="เค็ม"
                    >เค็ม</a-radio-button
                  >
                  <a-radio-button class="answer-radio" value="หวาน"
                    >หวาน</a-radio-button
                  >
                  <a-radio-button class="answer-radio" value="เผ็ด"
                    >เผ็ด</a-radio-button
                  >
                </a-radio-group>
              </a-form-item>

              <a-form-item label="ผัก ผลไม้">
                <a-radio-group
                  v-model="$v.answers.fifthStep.foodVegetableFruit.$model"
                  class="w-full"
                  buttonStyle="solid"
                >
                  <a-radio-button class="answer-radio" value="ทุกวัน"
                    >ทุกวัน</a-radio-button
                  >
                  <a-radio-button class="answer-radio" value="นานๆครั้ง"
                    >นานๆครั้ง</a-radio-button
                  >
                  <a-radio-button class="answer-radio" value="บางวัน"
                    >บางวัน</a-radio-button
                  >
                </a-radio-group>
              </a-form-item>

              <a-form-item label="อาหารมื้อเช้า" class>
                <a-radio-group
                  v-model="$v.answers.fifthStep.foodBreakfast.$model"
                  class="w-full"
                  buttonStyle="solid"
                >
                  <a-radio-button class="answer-radio" value="กิน"
                    >กิน</a-radio-button
                  >
                  <a-radio-button class="answer-radio" value="ไม่แน่นอน"
                    >ไม่แน่นอน</a-radio-button
                  >
                  <a-radio-button class="answer-radio" value="ไม่กิน"
                    >ไม่กิน</a-radio-button
                  >
                </a-radio-group>
              </a-form-item>

              <a-form-item class="w-full md:w-64">
                <a-button
                  @click="next()"
                  :disabled="$v.answers.fifthStep.$invalid"
                  type="primary"
                  html-type="submit"
                  class="w-full md:w-64"
                  >ขั้นตอนต่อไป</a-button
                >
              </a-form-item>
            </div>
          </div>
        </div>
      </div>

      <div id="step-sixth" v-show="currentStep == 5">
        <h1 class="text-2xl mb-4">การรับประทานยา</h1>

        <div class="flex flex-col md:flex-row mb-16">
          <div class="w-96">
            <!-- <h1 class="text-xl font-light">การรับประทานยา</h1> -->
          </div>
          <div>
            <div>
              <a-form-item label="ยาลดไขมัน">
                <a-radio-group
                  buttonStyle="solid"
                  v-model="$v.answers.sixthStep.medicineLipidLowering.$model"
                >
                  <a-radio-button class="answer-radio" value="รับประทานประจำ"
                    >รับประทานประจำ</a-radio-button
                  >
                  <a-radio-button class="answer-radio" value="เคยรับประทาน"
                    >เคยรับประทาน</a-radio-button
                  >
                  <a-radio-button class="answer-radio" value="ไม่รับประทาน"
                    >ไม่รับประทาน</a-radio-button
                  >
                </a-radio-group>
              </a-form-item>

              <a-form-item label="ฮอร์โมนทดแทนวัยทอง" class>
                <a-radio-group
                  buttonStyle="solid"
                  v-model="$v.answers.sixthStep.medicineHormone.$model"
                >
                  <a-radio-button class="answer-radio" value="รับประทานประจำ"
                    >รับประทานประจำ</a-radio-button
                  >
                  <a-radio-button class="answer-radio" value="เคยรับประทาน"
                    >เคยรับประทาน</a-radio-button
                  >
                  <a-radio-button class="answer-radio" value="ไม่รับประทาน"
                    >ไม่รับประทาน</a-radio-button
                  >
                </a-radio-group>
              </a-form-item>

              <a-form-item label="ยาลดความดันโลหิต">
                <a-radio-group
                  buttonStyle="solid"
                  v-model="$v.answers.sixthStep.medicineAntihypertensive.$model"
                >
                  <a-radio-button class="answer-radio" value="รับประทานประจำ"
                    >รับประทานประจำ</a-radio-button
                  >
                  <a-radio-button class="answer-radio" value="เคยรับประทาน"
                    >เคยรับประทาน</a-radio-button
                  >
                  <a-radio-button class="answer-radio" value="ไม่รับประทาน"
                    >ไม่รับประทาน</a-radio-button
                  >
                </a-radio-group>
              </a-form-item>

              <a-form-item class="w-full md:w-64">
                <a-button
                  @click="next()"
                  :disabled="$v.answers.sixthStep.$invalid"
                  type="primary"
                  html-type="submit"
                  class="w-full md:w-64"
                  >ขั้นตอนต่อไป</a-button
                >
              </a-form-item>
            </div>
          </div>
        </div>
      </div>

      <div id="step-seventh" v-show="currentStep == 6">
        <h1 class="text-2xl mb-4">สารเสพติด</h1>

        <div class="flex flex-col md:flex-row mb-16">
          <div class="w-96">
            <!-- <h1 class="text-xl font-light">พฤติกรรมการเสพติด</h1> -->
          </div>
          <div>
            <div>
              <a-form-item label="สูบบุหรี่" class>
                <a-radio-group
                  buttonStyle="solid"
                  v-model="$v.answers.seventhStep.hasSmoking.$model"
                >
                  <a-radio-button class="answer-radio" value="ไม่สูบ"
                    >ไม่สูบ</a-radio-button
                  >

                  <a-radio-button class="answer-radio" value="สูบ"
                    >สูบ</a-radio-button
                  >
                  <a-radio-button class="answer-radio" value="เคยสูบแต่เลิกแล้ว"
                    >เคยสูบแต่เลิกแล้ว</a-radio-button
                  >
                </a-radio-group>
              </a-form-item>

              <a-form-item label="ดื่มสุรา">
                <a-radio-group
                  buttonStyle="solid"
                  v-model="$v.answers.seventhStep.hasAlcohol.$model"
                >
                  <a-radio-button class="answer-radio" value="ไม่ดื่ม"
                    >ไม่ดื่ม</a-radio-button
                  >

                  <a-radio-button class="answer-radio" value="ดื่ม"
                    >ดื่ม</a-radio-button
                  >
                  <a-radio-button
                    class="answer-radio"
                    value="เคยดื่มแต่เลิกแล้ว"
                    >เคยดื่มแต่เลิกแล้ว</a-radio-button
                  >
                </a-radio-group>
              </a-form-item>

              <a-form-item class="w-full md:w-64">
                <a-button
                  @click="next()"
                  :disabled="$v.answers.seventhStep.$invalid"
                  type="primary"
                  html-type="submit"
                  class="w-full md:w-64"
                  >ขั้นตอนต่อไป</a-button
                >
              </a-form-item>
            </div>
          </div>
        </div>
      </div>

      <div id="step-eigth" v-show="currentStep == 7">
        <h1 class="text-2xl mb-4">พฤติกรรมความเครียด</h1>

        <div class="flex flex-col md:flex-row mb-16">
          <div class="w-96">
            <!-- <h1 class="text-xl font-light">พฤติกรรมความเครียด</h1> -->
          </div>
          <div>
            <div>
              <a-form-item label="ท่านมีบุคลิก (เลือกได้มากกว่า 1 ข้อ)">
                <a-checkbox-group
                  v-model="$v.answers.eigthStep.personality.$model"
                  :options="[
                    'ใจร้อน',
                    'หงุดหงิดง่าย',
                    'เอาจริงเอาจัง',
                    'รูัสึกกลัว/วิตกกังวล',
                    'ตื่นเต้นง่าย',
                  ]"
                  class="flex flex-col mb-8"
                />
              </a-form-item>

              <a-form-item label="งานและความรับผิดชอบ (เลือกได้มากกว่า 1 ข้อ)">
                <a-checkbox-group
                  v-model="$v.answers.eigthStep.responsibility.$model"
                  :options="[
                    'งานหนัก',
                    'ไม่มีเวลาพักผ่อน',
                    'เพื่อนร่วมงานมีปัญหา',
                    'ทำงานไม่ได้ดั่งใจ',
                    'ถูกตำหนิบ่อย',
                    'งานราบรื่นดีไม่มีปัญหา',
                  ]"
                  class="flex flex-col"
                />
              </a-form-item>

              <a-form-item label="ครอบครัวและสมาชิก (เลือกได้มากกว่า 1 ข้อ)">
                <a-checkbox-group
                  v-model="$v.answers.eigthStep.family.$model"
                  :options="[
                    'ต้องรับผิดชอบมาก',
                    'สัมพันธภาพไม่ค่อยดี',
                    'ไม่ค่อยเข้าใจกัน',
                    'ต่างคนต่างอยู่',
                    'ค่าใช้จ่ายมาก',
                    'ไม่มีคนช่วยทำงานบ้าน',
                    'เป็นสุขดีไม่มีปัญหา',
                  ]"
                  class="flex flex-col"
                />
              </a-form-item>

              <a-form-item label="สังคม (เลือกได้มากกว่า 1 ข้อ)" class>
                <a-checkbox-group
                  v-model="$v.answers.eigthStep.social.$model"
                  :options="[
                    'ไม่ค่อยได้สนใจ',
                    'ช่างวุ่นวายน่าเบื่อ',
                    'โชคดีมีเพื่อนสนิทไม่เครียด',
                    'มีแต่คนเห็นแก่ตัวเอาเปรียบ',
                    'ทำใจได้สบายๆ',
                  ]"
                  class="flex flex-col"
                />
              </a-form-item>

              <a-form-item class="w-full md:w-64">
                <a-button
                  @click="next()"
                  :disabled="$v.answers.eigthStep.$invalid"
                  type="primary"
                  html-type="submit"
                  class="w-full md:w-64"
                  >ขั้นตอนต่อไป</a-button
                >
              </a-form-item>
            </div>
          </div>
        </div>
      </div>

      <div id="step-eigth" v-show="currentStep == 8">
        <h1 class="text-2xl mb-4">การตรวจร่างกาย</h1>

        <div class="flex flex-col md:flex-row mb-16">
          <div class="w-96">
            <!-- <h1 class="text-xl font-light">การตรวจร่างกาย</h1> -->
          </div>
          <div>
            <div>
              <div class="flex flex-col md:flex-row">
                <a-form-item label="น้ำหนัก" class="mr-4 w-full">
                  <p class="text-gray-400">
                    {{
                      selfMonitoringData && selfMonitoringData.weight !== "-"
                        ? "(ข้อมูลจาก CMU Smart Self-Monitoring)"
                        : ""
                    }}
                  </p>

                  <a-input
                    v-model="$v.answers.ninthStep.weight.$model"
                    addonAfter="กิโลกรัม"
                    type="number"
                  />
                </a-form-item>

                <a-form-item label="ส่วนสูง" class="w-full">
                  <p class="text-gray-400">
                    {{
                      selfMonitoringData && selfMonitoringData.height !== "-"
                        ? "(ข้อมูลจาก CMU Smart Self-Monitoring)"
                        : ""
                    }}
                  </p>
                  <a-input
                    v-model="$v.answers.ninthStep.height.$model"
                    type="number"
                    addonAfter="เซนติเมตร"
                  />
                </a-form-item>
              </div>

              <div class="flex flex-col md:flex-row">
                <a-form-item label="ดัชนีมวลกาย (BMI)" class="mr-4 w-full">
                  <a-input
                    v-model="bmi"
                    type="number"
                    step="0.01"
                    addonAfter="กิโลกรัม/เมตรยกกำลังสอง"
                  />
                </a-form-item>

                <a-form-item label="เส้นรอบเอว(วัดผ่านสะดือ)" class="w-full">
                  <a-input
                    v-model="$v.answers.ninthStep.waistLength.$model"
                    type="number"
                    addonAfter="นิ้ว"
                  />
                </a-form-item>
              </div>

              <a-form-item label="รอบสะโพก(ผ่านปุ่มกระดูก Ischium)" class>
                <a-input
                  v-model="$v.answers.ninthStep.hipLength.$model"
                  class="w-full"
                  type="number"
                  addonAfter="นิ้ว"
                />
              </a-form-item>

              <div class="flex flex-col md:flex-row">
                <a-form-item
                  label="ระดับน้ำตาลในเลือดจากหลอดเลือดฝอย(DTX)"
                  extra="กรณีมากกว่าหรือเท่ากับ 110 มก% ให้นัดทำ FBS ต่อ"
                  class="mr-4 w-full"
                >
                  <a-input
                    v-model="$v.answers.ninthStep.dtx.$model"
                    type="number"
                    class="flex-1"
                    addonAfter="มก.%"
                  />
                </a-form-item>

                <a-form-item label="เจาะหลังรับประทานอาหาร" class="w-full">
                  <a-input
                    v-model="$v.answers.ninthStep.dtxAfterMeal.$model"
                    type="number"
                    addonAfter="ชั่วโมง"
                  />
                </a-form-item>
              </div>

              <a-form-item
                label="ความดันโลหิต (บน/ล่าง)"
                extra="กรณีมากกว่าหรือเท่ากับ 140/90 หรือ Diastolic มากกว่า 90; Systolic มากกว่า 140 ให้นัดวัดซ้ำ และทำ FBS ต่อ"
                class="mr-4 w-full"
              >
                <p class="text-gray-400">
                  {{
                    selfMonitoringData && selfMonitoringData.bpHigh !== "-"
                      ? "(ข้อมูลจาก CMU Smart Self-Monitoring)"
                      : ""
                  }}
                </p>

                <a-input
                  v-model="$v.answers.ninthStep.bloodPressure.$model"
                  addonAfter="มม.ปรอท"
                />
              </a-form-item>

              <a-form-item class="w-full md:w-64">
                <a-button
                  @click="next"
                  :disabled="$v.answers.ninthStep.$invalid"
                  type="primary"
                  html-type="submit"
                  class="w-full md:w-64"
                  >ขั้นตอนต่อไป</a-button
                >
              </a-form-item>
            </div>
          </div>
        </div>
      </div>
    </div>

    <a-modal
      title="ขออนุญาตเข้าถึงข้อมูล"
      v-model="acknowledgementVisible"
      :width="640"
      @ok="acknowledgementVisible = false"
      @cancel="$router.replace('/assessments')"
      okText="อนุญาต"
      cancelText="ยกเลิก"
    >
      <p class="text-lg mb-4">
        เมื่อท่านได้ทำการอนุญาตให้เข้าถึงข้อมูลสุขภาพ
        เฉพาะท่านเท่านั้นที่สามารถเห็นข้อมูลของท่านเอง
        โดยท่านจะได้รับคำแนะนำการดูแลสุขภาพเบื้องต้นภายหลังเสร็จสิ้นการทำแบบประเมินในระบบ
        CMU i-Health
      </p>

      <p class="text-lg mb-4">
        ข้อมูลของท่านจะถูกเก็บไว้เป็นความลับ ชื่อ และนามสกุล
        ของท่านจะไม่ถูกนำมาเปิดเผย
      </p>

      <p class="text-lg mb-4">
        คณะกรรมการโครงการพัฒนาศักยภาพการสร้างเสริมสุขภาพของบุคลากรมหาวิทยาลัยเชียงใหม่
        สำหรับการขับเคลื่อนสู่มหาวิทยาลัยสุขภาพสามารถเห็นข้อมูลสุขภาพของบุคลากรมหาวิทยาลัยเชียงใหม่ในภาพรวมเท่านั้น
      </p>
    </a-modal>
  </div>
</template>

<script>
const { required, minLength } = require("vuelidate/lib/validators");

import FORMS from "../data/survey";
import { notification } from "ant-design-vue";
import axios from "axios";

export default {
  created() {
    this.fetchHealthMonitoringData();

    // this.answers.firstStep.kindOfWork = "ทำงานกลางแจ้ง";
    // this.answers.firstStep.lifeCost = "เป็นหนี้";

    // this.answers.ninthStep.weight = 220;
  },
  mounted() {
    window.onbeforeunload = function() {
      return "คุณต้องการออกจากแบบสอบถามหรือไม่";
    };
  },
  beforeDestroy() {
    window.onbeforeunload = null;
  },
  data() {
    return {
      hasMonitoringData: false,
      currentStep: 0,
      finished: false,
      acknowledgementVisible: false,
      answers: {
        firstStep: {
          salary: 0,
          lifeCost: "",
          kindOfWork: "",
        },
        secondStep: {
          fatherDisease: "",
          motherDisease: "",
          sibblingDisease: "",
        },
        thirdStep: {
          yearlyHealthCheck: "",
          fatWhenWasChild: "",
          diabetes: "",
          bloodPressure: "",
          storke: "",
          liver: "",
          treatmentFrequency: "",
        },
        forthStep: {
          hasExercise: "",
          exerciseFrequency: "",
          exerciseDuration: "",
          exerciseType: "",
        },
        fifthStep: {
          foodSource: "",
          foodFat: "",
          foodCoconutMilk: "",
          foodTaste: "",
          foodVegetableFruit: "",
          foodBreakfast: "",
        },
        sixthStep: {
          medicineLipidLowering: "",
          medicineHormone: "",
          medicineAntihypertensive: "",
        },
        seventhStep: {
          hasSmoking: "",
          hasAlcohol: "",
        },
        eigthStep: {
          personality: [],
          responsibility: [],
          family: [],
          social: [],
        },
        ninthStep: {
          weight: null,
          height: null,
          bmi: 0,
          waistLength: null,
          hipLength: null,
          dtx: null,
          dtxAfterMeal: null,
          bloodPressure: null,
        },
      },
      selfMonitoringModalVisiblity: false,
      selfMonitoringData: null,
    };
  },
  validations: {
    answers: {
      firstStep: {
        salary: { required },
        lifeCost: { required },
        kindOfWork: { required },
      },
      secondStep: {
        fatherDisease: { required },
        motherDisease: { required },
        sibblingDisease: { required },
      },
      thirdStep: {
        yearlyHealthCheck: { required },
        fatWhenWasChild: { required },
        diabetes: { required },
        bloodPressure: { required },
        storke: { required },
        liver: { required },
      },
      forthStep: {
        hasExercise: { required },
        exerciseFrequency: {},
        exerciseDuration: {},
        exerciseType: {},
      },
      fifthStep: {
        foodSource: { required },
        foodFat: { required },
        foodCoconutMilk: { required },
        foodTaste: { required },
        foodVegetableFruit: { required },
        foodBreakfast: { required },
      },
      sixthStep: {
        medicineLipidLowering: { required },
        medicineHormone: { required },
        medicineAntihypertensive: { required },
      },
      seventhStep: {
        hasSmoking: { required },
        hasAlcohol: { required },
      },
      eigthStep: {
        personality: {},
        responsibility: {},
        family: {},
        social: {},
      },
      ninthStep: {
        weight: { required },
        height: { required },
        bmi: 0,
        waistLength: {},
        hipLength: {},
        dtx: {},
        dtxAfterMeal: {},
        bloodPressure: {},
      },
    },
  },
  computed: {
    bmi() {
      const { weight, height } = this.answers.ninthStep;
      const heightInMeter = height / 100;
      const bmi = weight / Math.pow(heightInMeter, 2);

      this.answers.ninthStep.bmi = bmi.toFixed(2);

      return bmi.toFixed(2);
    },
    hasAnyDisease() {
      const {
        fatWhenWasChild,
        diabetes,
        bloodPressure,
        storke,
        liver,
      } = this.answers.thirdStep;

      const diseases = [
        fatWhenWasChild,
        diabetes,
        bloodPressure,
        storke,
        liver,
      ];

      return diseases.some((disease) => disease === "มี");
    },
    hasExercise() {
      return this.answers.forthStep.hasExercise == "ออกกำลังกาย";
    },
    foodRisks() {
      const {
        foodFat,
        foodCoconutMilk,
        foodTaste,
        foodBreakfast,
      } = this.answers.fifthStep;

      const foodRisks = [];

      const fatRisk = foodFat == "ทุกวัน";
      const coconutMilkRisk = foodCoconutMilk == "ทุกวัน";
      const tasteRisk = foodTaste == "เค็ม" || foodTaste == "หวาน";
      const breakfastRisk = foodBreakfast == "ไม่กิน";

      return {
        fatRisk,
        coconutMilkRisk,
        tasteRisk,
        breakfastRisk,
      };
    },
    hasFoodRiskFilled() {
      const {
        foodFat,
        foodCoconutMilk,
        foodTaste,
        foodBreakfast,
      } = this.answers.fifthStep;

      return (
        foodFat != "" ||
        foodCoconutMilk != "" ||
        foodTaste != "" ||
        foodBreakfast != ""
      );
    },
    hasFoodRisk() {
      const onlyRisks = Object.keys(this.foodRisks).filter(
        (key) => this.foodRisks[key] == true
      );

      const risk = {
        name: "การบริโภคอาหาร",
        risk: onlyRisks.length >= 1,
        filled: this.hasFoodRiskFilled,
      };

      return risk;
    },
    hasBmiRisk() {
      const risk = {
        name: "ดัชนีมวลกาย (BMI)",
        risk: this.bmi >= 23,
        filled: this.bmi != "NaN" && this.bmi != "Infinity",
      };

      return risk;
    },
    hasAlcoholRisk() {
      const { hasAlcohol } = this.answers.seventhStep;

      const risk = {
        name: "การดื่มเครื่องดื่มแอลกอฮอลล์",
        risk: hasAlcohol == "ดื่ม",
        filled: hasAlcohol != "",
      };

      return risk;
    },
    hasSmokingRisk() {
      const { hasSmoking } = this.answers.seventhStep;

      const risk = {
        name: "การสูบบุหรี่",
        risk: hasSmoking == "สูบ",
        filled: hasSmoking != "",
      };

      return risk;
    },
    hasBodyActivityRisk() {
      const { hasExercise } = this.answers.forthStep;

      const risk = {
        name: "กิจกรรมทางกาย",
        risk: hasExercise == "ไม่ได้ออกกำลังกาย",
        filled: hasExercise != "",
      };

      return risk;
    },
    hasWaistRisk() {
      if (!this.answers.ninthStep.waistLength) {
        return {
          name: "เส้นรอบเอว",
          risk: false,
          filled: false,
        };
      }

      const { waistLength } = this.answers.ninthStep;

      const risk = {
        name: "เส้นรอบเอว",
        risk: waistLength >= 36,
        filled: true,
      };

      return risk;
    },
    hasDiabetesRisk() {
      const { diabetes, treatmentFrequency } = this.answers.thirdStep;

      const risk = {
        name: "เป็นเบาหวาน",
        risk: diabetes == "มี",
        filled: diabetes != "",
      };

      return risk;
    },
    hasSibblingStrokeRisk() {
      const {
        fatherDisease,
        motherDisease,
        sibblingDisease,
      } = this.answers.secondStep;

      const risk = {
        name: "มีประวัติญาติสายตรงเป็น โรคหัวใจขาดเลือดหรืออัมพาต",
        risk:
          fatherDisease == "โรคหลอดเลือดหัวใจ" ||
          motherDisease == "โรคหลอดเลือดหัวใจ" ||
          sibblingDisease == "โรคหลอดเลือดหัวใจ",
        filled:
          fatherDisease != "" || motherDisease != "" || sibblingDisease != "",
      };

      return risk;
    },
    hasBloodPressureRisk() {
      const { bloodPressure } = this.answers.ninthStep;

      if (!bloodPressure) {
        return {
          name: "ระดับความดันโลหิตสูง",
          risk: false,
          filled: false,
        };
      }

      const [dias, sys] = bloodPressure.split("/");

      const risk = {
        name: "ระดับความดันโลหิตสูง",
        risk: dias >= 140 && sys >= 90,
        filled: true,
      };

      return risk;
    },
    hasStrokeRisk() {
      const { storke, treatmentFrequency } = this.answers.thirdStep;

      const risk = {
        name: "โรคหัวใจและหลอดเลือด",
        risk: storke == "มี",
        filled: storke != "",
      };

      return risk;
    },
    hasLowRisk() {
      return (
        this.hasFoodRisk.risk == true ||
        this.hasBmiRisk.risk == true ||
        this.hasWaistRisk.risk == true
      );
    },
    hasMediumRisk() {
      const risks = [
        this.hasFoodRisk,
        this.hasAlcoholRisk,
        this.hasBodyActivityRisk,
        this.hasBmiRisk,
        this.hasWaistRisk,
      ];

      return risks.filter((risk) => risk.risk == true).length >= 2;
    },
    hasHighRisk() {
      const risks = [
        this.hasSmokingRisk,
        this.hasFoodRisk,
        this.hasAlcoholRisk,
        this.hasBodyActivityRisk,
        this.hasBmiRisk,
        this.hasWaistRisk,
      ];

      const riskCount = risks.filter((risk) => risk.risk == true).length;

      return (
        riskCount == 2 ||
        this.hasDiabetesRisk.risk ||
        this.hasSibblingStrokeRisk.risk
      );
    },
    hasVeryHighRisk() {
      const risks = [
        this.hasSmokingRisk,
        this.hasFoodRisk,
        this.hasAlcoholRisk,
        this.hasBodyActivityRisk,
        this.hasBmiRisk,
        this.hasWaistRisk,
      ];

      const riskCount = risks.filter((risk) => risk.risk == true).length;

      return riskCount >= 3;
    },
    hasUltraHighRisk() {
      const risks = [
        this.hasSmokingRisk,
        this.hasFoodRisk,
        this.hasAlcoholRisk,
        this.hasBodyActivityRisk,
        this.hasBmiRisk,
        this.hasWaistRisk,
      ];

      const riskCount = risks.filter((topic) => topic.risk == true).length;

      return riskCount > 5 || this.hasStrokeRisk.risk == true;
    },
    finalResult() {
      let riskLevel = {
        name: "ความเสี่ยงต่ำ",
      };

      if (this.hasLowRisk) {
        riskLevel = {
          name: "ความเสี่ยงต่ำ",
        };
      }

      if (this.hasMediumRisk) {
        riskLevel = {
          name: "ความเสี่ยงปานกลาง",
        };
      }

      if (this.hasHighRisk) {
        riskLevel = {
          name: "ความเสี่ยงสูง",
        };
      }

      if (this.hasVeryHighRisk) {
        riskLevel = {
          name: "ความเสี่ยงสูงปานกลาง",
        };
      }

      if (this.hasUltraHighRisk) {
        riskLevel = {
          name: "ความเสี่ยงสูงมาก",
        };
      }

      return riskLevel;
    },
    riskTopics() {
      const {
        hasAlcoholRisk,
        hasBloodPressureRisk,
        hasBmiRisk,
        hasBodyActivityRisk,
        hasDiabetesRisk,
        hasFoodRisk,
        hasSibblingStrokeRisk,
        hasSmokingRisk,
        hasStrokeRisk,
        hasWaistRisk,
      } = this;

      const topics = [
        hasAlcoholRisk,
        hasBloodPressureRisk,
        hasBmiRisk,
        hasBodyActivityRisk,
        hasDiabetesRisk,
        hasFoodRisk,
        hasSibblingStrokeRisk,
        hasSmokingRisk,
        hasStrokeRisk,
        hasWaistRisk,
      ];

      return topics;
    },
  },
  methods: {
    next() {
      this.scrollToTop();

      if (this.currentStep == 8) {
        this.submit();
        return;
      }

      this.currentStep++;
    },
    scrollToTop() {
      const app = this.$parent.$el.querySelector("#main");
      app.scrollTo(0, 0);
    },
    async submit() {
      let loader = this.$loading.show({
        // Optional parameters
        container: this.fullPage ? null : this.$refs.formContainer,
      });

      try {
        const response = await axios({
          method: "POST",
          url: `${process.env.VUE_APP_API_URL}/me/risk-assessment`,
          headers: { authorization: `Bearer ${localStorage.getItem("TOKEN")}` },
          data: {
            finalResult: this.finalResult.name,
            rawResult: JSON.stringify(this.answers),
            riskTopics: JSON.stringify(this.riskTopics),
          },
        });

        loader.hide();

        this.$notify({
          type: "success",
          group: "foo",
          title: "บันทึกผลการคัดกรองแล้ว",
          text: "ข้อมูลของท่านจะถูกบันทึกในฐานข้อมูลและสามารถเข้าดูย้อนหลังได้",
        });

        const { id } = response.data;

        this.$router.push(`/risk-assessment/${id}`);
      } catch (error) {
        console.log(error);

        loader.hide();

        this.$notify({
          type: "error",
          group: "foo",
          title: "บันทึกไม่สำเร็จ",
          text: "ลองใหม่อีกครั้ง",
        });
      }
    },
    leaving(event) {
      console.log("test");
    },
    async fetchHealthMonitoringData() {
      try {
        const date = new Date().toJSON().slice(0, 10);
        const { user } = this.$store.state;

        const response = await axios({
          method: "GET",
          url: `https://api-cmupersonas.system-on.cloud/v1d/public/health/data?email=${user.email}&date=${date}`,
          // url:
          //   "https://api-cmupersonas.system-on.cloud/v1d/public/health/data?email=parichat.ong@cmu.ac.th&date=2022-03-01",
          auth: {
            username: "cmuhealth",
            password: "cmuhealth01",
          },
        });

        if (response.data.status == "success") {
          this.selfMonitoringData = response.data.data;

          const {
            bloodOxygen,
            bpHigh,
            bpLow,
            fatMass,
            height,
            idealWeight,
            steps,
            weight,
            workout,
          } = response.data.data;

          this.hasMonitoringData = true;

          this.answers.ninthStep.weight = weight;
          this.answers.ninthStep.height = height;
          this.answers.ninthStep.bloodPressure = `${bpHigh}/${bpLow}`;
          this.answers.forthStep.hasExercise =
            workout == "Y" ? "ออกกำลังกาย" : "ไม่ได้ออกกำลังกาย";
        }
      } catch (error) {}
    },
  },
};
</script>

<style>
.ant-checkbox-wrapper.ant-checkbox-group-item {
  margin-bottom: 12px;
}

.ant-steps-item {
  cursor: pointer;
}

.ant-radio-button-wrapper {
  color: #616161;
}
.doodle-bg {
  background: url("~@/assets/landing-login.png") no-repeat;
  background-position: 0;
}

.ant-modal-title {
  font-size: 22px;
  font-weight: bold;
}

.ant-tabs-nav-container,
.ant-tabs-tabpane {
  font-size: 15px;
}

.ant-radio-group {
  width: 100%;
}
</style>
